import { connect } from 'react-redux'

import TrialCollaborationModal from './components/TrialCollaborationModal'

export default connect(
  () => ({}),
  () => ({}),
)(TrialCollaborationModal)
